// extracted by mini-css-extract-plugin
export default {"logoSpinner":"LogoSpinner_logoSpinner__GI6pY","spinner":"LogoSpinner_spinner__ICjJl","logospin":"LogoSpinner_logospin__rbsB9"};